export const capitalizeEachWord = (string) => {
  const capitalizedString = string
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");

  return capitalizedString;
};
